import { ItemType, ItemTypeMapper, TemplateItem } from "@/@types/flows/emailTemplates/items";
import { TemplateItemFactory } from "@/app/flows/emailTemplates/utils/TemplateItemFactory";
import { cloneDeep } from "lodash";

export abstract class TemplateItemsManager {
  private static items: TemplateItem[];

  static initializeTemplateItems(items: TemplateItem[]) {
    this.items = items;
  }

  static getCurrentItems() {
    return this.items;
  }

  private static getCurrentItemIndex(id: string): number {
    const index = this.items.findIndex((i) => i.id === id);

    return index;
  }

  static addItem(id: string | undefined, type: ItemType): string {
    const index = id ? this.getCurrentItemIndex(id) : -1;
    const newItem = TemplateItemFactory.create(type);

    this.items.splice(index + 1, 0, newItem);

    return newItem.id;
  }

  static editElement(
    id: string,
    editedItem: Omit<ItemTypeMapper[ItemType], "id" | "type">
  ): TemplateItem[] {
    const index = this.getCurrentItemIndex(id);
    Object.assign(this.items[index], editedItem);

    return this.items;
  }

  static copyItem(item: TemplateItem) {
    const index = this.getCurrentItemIndex(item.id);
    const copyElement = cloneDeep(item);
    const newItem = TemplateItemFactory.create(item.type);
    copyElement.id = newItem.id;

    this.items.splice(index + 1, 0, copyElement);
  }

  static removeItem(id: string) {
    const index = this.getCurrentItemIndex(id);

    this.items.splice(index, 1);
  }
}
